import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './ProductCard.css';
import API from '../../utils/api';
const FALLBACK_IMG = 'https://images.unsplash.com/photo-1586339949916-3e9457bef6d3?w=400';

/**
 * Works with both catalog products and legacy products.
 * Catalog product shape:
 *   { id, name, slug, mainImage, shortDescription, startingPrice,
 *     isFeatured, category: {name, slug}, subcategory: {slug} }
 *
 * URL scheme:
 *   Category page  : /:categorySlug
 *   Product detail : /category/:catSlug/:productSlug
 *                    /category/:catSlug/:subSlug/:productSlug  (with subcategory)
 */
const ProductCard = ({ product }) => {
  const isCatalog = Boolean(product.category && typeof product.category === 'object');

  // ── URL ────────────────────────────────────────────────────────
  let href = `/products/${product.slug}`; // legacy fallback
  if (isCatalog) {
    const catSlug = product.category?.slug || '';
    const subSlug = product.subcategory?.slug || '';
    href = subSlug
      ? `/category/${catSlug}/${subSlug}/${product.slug}`
      : `/category/${catSlug}/${product.slug}`;
  }

  // ── Price display ──────────────────────────────────────────────
  const hasPrice      = product.startingPrice != null && product.startingPrice !== '';
  const startingPrice = hasPrice ? parseFloat(product.startingPrice) : null;

  // ── Category label ─────────────────────────────────────────────
  const categoryLabel = isCatalog
    ? product.category?.name || ''
    : (product.category || '').replace(/-/g, ' ');

  // ── Image ──────────────────────────────────────────────────────
  const image = product.mainImage || FALLBACK_IMG;

  const prefetch = () => {
    API.get(`/catalog/public/products/${product.slug}`).catch(() => {});
  };

  return (
    <Link to={href} className="product-card" onMouseEnter={prefetch} onTouchStart={prefetch}>
      <div className="product-card-img">
        <img src={image} alt={product.name} loading="lazy" onError={e => { e.target.src = FALLBACK_IMG; }} />
        {product.isFeatured && <span className="badge-featured">Featured</span>}
      </div>
      <div className="product-card-body">
        {categoryLabel && <span className="product-category">{categoryLabel}</span>}
        <h3 className="product-name">{product.name}</h3>
        {product.shortDescription && (
          <p className="product-desc">{product.shortDescription}</p>
        )}
        <div className="product-footer">
          <div className="product-price">
            {startingPrice != null ? (
              <span className="price-from">
                <span className="price-from-label">Starting from </span>
                <span className="price-sale">₹{startingPrice.toLocaleString('en-IN')}</span>
              </span>
            ) : (
              <span className="price-on-request">Price on Request</span>
            )}
          </div>
          <span className="card-view-btn">
            View <FiArrowRight size={13} />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;